
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/license-status",
      function () {
        return require("private-next-pages/license-status/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/license-status"])
      });
    }
  